import { render, staticRenderFns } from "./StripColor.vue?vue&type=template&id=93c43d62&"
import script from "./StripColor.vue?vue&type=script&lang=js&"
export * from "./StripColor.vue?vue&type=script&lang=js&"
import style0 from "./StripColor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports